import { makeSegmentTrackCall } from 'client/javascript/analytics';

export const sendNearByBuildingEvent = (label) => {
  makeSegmentTrackCall('Interation', { label });
};
